import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { Grid, InputLabel, Dialog, AppBar, Toolbar, Typography, Button } from "@material-ui/core";
import Slide from "@material-ui/core/Slide";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import RichTextEditor from "../../richTextEditor/RichTextEditor";
import { BookingStatusType, ProfileType } from "../../../types/enum";
import moment from "moment";

@inject("bookingRequestStore", "profileStore", "agentVenueStore", "agentActStore")
@observer
class BookingClientContract extends Component {
    state = {
        contractFullState: false
    };

    componentDidMount() {
        let { clientContract, tempClientContract } = this.props.bookingRequestStore.booking;
        if (!clientContract || clientContract == '<p></p>' && tempClientContract) {
            this.props.bookingRequestStore.setBooking("clientContract", tempClientContract)
        }
    }

    handleContractChange = e => {
        this.props.bookingRequestStore.setBooking("clientContract", e);
    };

    handleOpenContract = () => {
        this.setState({
            ...this.state,
            contractFullState: true
        });
    };

    handleCloseContract = () => {
        this.setState({
            ...this.state,
            contractFullState: false
        });
    };

    transition = props => {
        return <Slide direction="up" {...props} />;
    };

    render() {
        let { clientContract, status, createdById, dateStart, tempClientContract } = this.props.bookingRequestStore.booking;

        const { currentProfile } = this.props.profileStore;
        const isStaff = currentProfile && currentProfile.type === ProfileType.Staff.ordinal;
        const {isActChange, actIsChanging} = this.props
        let confirmedEditable =
            status !== BookingStatusType.Cancelled.ordinal &&
            status !== BookingStatusType.Completed.ordinal &&
            moment(dateStart).endOf("day") >= moment() &&
            (!createdById || createdById === currentProfile.id || isStaff);

        return (
            <Fragment>
                <Grid container spacing={8}>
                    <Grid item xs={12} lg={12}>
                        <Grid container spacing={0}>
                            <Grid
                                item
                                xs={12}
                                className=""
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end"
                                }}
                            >
                                <Button color="primary" size="small" onClick={this.handleOpenContract} className="button-small fullscreen-bio">
                                    <FullscreenIcon />
                                    <Typography>Fullscreen</Typography>
                                </Button>
                            </Grid>
                            <Grid item xs={12}>
                                <RichTextEditor
                                    id="booking-client-contract-rte"
                                    value={clientContract}
                                    onChange={this.handleContractChange}
                                    readOnly={!confirmedEditable}
                                    resetEditor={isActChange || this.state.contractFullState} 
                                    onChangeEditor={actIsChanging}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Dialog fullScreen open={this.state.contractFullState} onClose={this.handleCloseContract} transition={this.transition}>
                    <AppBar style={{ position: "relative" }}>
                        <Toolbar>
                            <Typography variant="title" color="inherit" style={{ flex: 1 }}>
                                Contract
                            </Typography>
                            <Button color="inherit" onClick={this.handleCloseContract}>
                                Exit Fullscreen
                            </Button>
                        </Toolbar>
                    </AppBar>
                    <div className="fullscreen-rich-text">
                        <RichTextEditor value={clientContract} onChange={this.handleContractChange} readOnly={!confirmedEditable} />
                    </div>
                </Dialog>
            </Fragment>
        );
    }
}

export default BookingClientContract;
